import { render, staticRenderFns } from "./Pot.vue?vue&type=template&id=1f836fa3"
import script from "./Pot.vue?vue&type=script&lang=js"
export * from "./Pot.vue?vue&type=script&lang=js"
import style0 from "./Pot.vue?vue&type=style&index=0&id=1f836fa3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports